import { Zap, Phone, MapPin, Clock, Mail } from 'lucide-react';

export const SiteFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-zinc-950 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <a href="#" className="flex items-center gap-2 mb-6" data-testid="footer-logo">
              <div className="w-10 h-10 bg-yellow-400 flex items-center justify-center">
                <Zap className="w-6 h-6 text-black" aria-hidden="true" />
              </div>
              <div>
                <span className="text-lg font-bold text-white tracking-tight">Fred Joules</span>
                <span className="block text-xs text-zinc-400 tracking-wider uppercase">Electricians</span>
              </div>
            </a>
            <p className="text-zinc-400 text-sm">
              Portland's trusted electrical experts. Licensed, insured, and available 7 days a week.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+19712652635"
                  className="flex items-center gap-3 text-zinc-400 hover:text-yellow-400 transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-5 h-5" aria-hidden="true" />
                  <span>(971) 265-2635</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-zinc-400">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" aria-hidden="true" />
                <span data-testid="footer-address">
                  8644 SW Canyon Rd #1590<br />
                  Portland, OR 97225
                </span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-white font-semibold mb-6">Business Hours</h4>
            <div className="flex items-start gap-3 text-zinc-400">
              <Clock className="w-5 h-5 flex-shrink-0 mt-0.5" aria-hidden="true" />
              <div>
                <p className="text-white font-medium" data-testid="footer-hours">8:00 AM - 8:00 PM</p>
                <p className="text-sm">Monday - Sunday</p>
                <p className="text-yellow-400 text-sm mt-2">Open 7 Days a Week</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-services">
                  Our Services
                </a>
              </li>
              <li>
                <a href="#about" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-about">
                  About Us
                </a>
              </li>
              <li>
                <a href="#why-us" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-why-us">
                  Why Choose Us
                </a>
              </li>
              <li>
                <a href="#contact" className="text-zinc-400 hover:text-white transition-colors" data-testid="footer-link-contact">
                  Request a Quote
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-zinc-500 text-sm" data-testid="footer-copyright">
            © {currentYear} Fred Joules Electricians. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="text-xs text-zinc-600">Licensed & Insured</span>
            <span className="text-zinc-700">|</span>
            <span className="text-xs text-zinc-600">Serving Portland & Beaverton</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
